// extracted by mini-css-extract-plugin
export default {"outerDiv":"courses-page_outerDiv__3Ec0y","cardOuterDiv":"courses-page_cardOuterDiv__BvkYb","vNameText":"courses-page_vNameText__rfIln","vDescText":"courses-page_vDescText__tXruW"};